import { render, staticRenderFns } from "./class-test.vue?vue&type=template&id=1772fede"
import script from "./class-test.vue?vue&type=script&lang=js"
export * from "./class-test.vue?vue&type=script&lang=js"
import style0 from "./class-test.vue?vue&type=style&index=0&id=1772fede&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports